/**
 * Fashion Product Card - Color Swatch Handler
 * 
 * This script handles color swatch functionality for the fashion product cards.
 * It allows users to change product images by clicking on color swatches.
 */

if (!customElements.get('fashion-product-card')) {
  class FashionProductCard extends HTMLElement {
    constructor() {
      super();
      this.colorSwatches = this.querySelectorAll('.fashion-color-swatch');
      this.mainImage = this.querySelector('.main-image');
      this.variantImagesContainer = this.querySelector('.variant-images');
      
      this.initColorSwatches();
    }

    /**
     * Initialize color swatches click events
     */
    initColorSwatches() {
      if (!this.colorSwatches.length) return;
      
      // Set the first swatch as active by default
      if (this.colorSwatches[0]) {
        this.colorSwatches[0].classList.add('active');
      }
      
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', this.handleColorSwatchClick.bind(this));
      });
    }
    
    /**
     * Handle color swatch click
     * @param {Event} event - Click event
     */
    handleColorSwatchClick(event) {
      event.preventDefault();
      
      const clickedSwatch = event.currentTarget;
      const variantId = clickedSwatch.getAttribute('data-variant-id');
      
      // Remove active class from all swatches
      this.colorSwatches.forEach(swatch => {
        swatch.classList.remove('active');
      });
      
      // Add active class to clicked swatch
      clickedSwatch.classList.add('active');
      
      // Change image if variant has an image
      if (variantId && this.variantImagesContainer) {
        const variantImageElement = this.variantImagesContainer.querySelector(`[data-variant-id="${variantId}"]`);
        
        if (variantImageElement && this.mainImage) {
          const variantImageUrl = variantImageElement.getAttribute('data-variant-image');
          
          if (variantImageUrl) {
            this.mainImage.src = variantImageUrl;
          }
        }
      }
    }
  }

  customElements.define('fashion-product-card', FashionProductCard);
}